import { PerksPage } from '@src/components/sco/Perks/Layout/PerksLayout';
import { PerksMainPanel } from '@src/components/sco/Perks/Layout/PerksMainPanel';
import { PartnerProfile } from '@src/components/sco/Perks/PartnerProfile';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { useParams } from 'next/navigation';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default PerksPage(function Page(props) {
  const routerParams = useParams();
  const activeContent = useActiveContentContext();
  useUniversalEffect(() => {
    activeContent.setSiteSection('perks.partners.single');
  });
  return <PerksMainPanel>
      <PartnerProfile slug={`${routerParams?.partnerSlug}`} />
    </PerksMainPanel>;
});